export default __webpack_public_path__ + "static/media/bxl-javascript.9a73de62.svg";